import React from 'react';
import { Form } from 'react-bootstrap';
import LazyImage from '../../../components/CustomLibraries/LazyImage';
import './css/spqAnswer.scss';
const AnswerTypeImage = ({ data, qNo, onChangeCheck }) => {
  return (
    <div className="w-100 spqAswerTypeImage">
      <div className="row flex-wrap mt-n3 ms-n3">
        {data?.options?.map((_opt, _idx) => (
          <div className="col-sm-3 spqAswerTypeImageBox mt-3 ps-3" key={_idx + 1}>
            <div className="w-100 spqAswerTypeImageBoxIn rounded position-relative overflow-hidden">
              <input
                className="position-absolute top-0 start-0 w-100 h-100 z-3 cursorPointer opacity-0"
                type="checkbox"
                name={`qNo${qNo}`}
                checked={_opt.isChecked}
                id={`radio${qNo}${_opt.id}`}
                onChange={() => {
                  onChangeCheck(_opt.id, _idx);
                }}
              />
              <label className="w-100 h-100 position-relative">
                <LazyImage
                  src={_opt.value}
                  alt="Select Image"
                  className="object-fit-cover w-100 h-100 float-start"
                />
                <div className="overlay bg-black bg-opacity-10"></div>
              </label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnswerTypeImage;
